LS.util.route({
	'account': {
		'$guard:eval': {
			'saves': {
				'$index': {
					':preload': 'account.saves:preload',
					':load': 'account.saves',
					':unload': 'account.saves:unload'
				}
			}
		}
	}
});